import { BrowserRouter, Navigate, NavLink, Route, Routes, useSearchParams } from 'react-router-dom'
import {
  ClickIdsPage,
  ConsentPage,
  EmailPage,
  EngagementPage,
  EventQueuePage,
  FileDownloadPage,
  HomePage,
  KITCHENSINK_PAGES,
  KitchensinkShell,
  LiftAiPage,
  navLinkStyle,
  PageA,
  PageB,
  ProductImpressionPage,
  readConfig,
  ReinitPage,
  TrackingTogglePage,
} from '@chilipiper/kitchensink-shared'
import type { ConfigParamKey } from '@chilipiper/kitchensink-shared'

const Layout = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const config = readConfig(searchParams.toString())

  const onParamChange = (key: ConfigParamKey, value: string) => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev)
        if (value) {
          next.set(key, value)
        } else {
          next.delete(key)
        }
        return next
      },
      { replace: true }
    )
  }

  const withSearch = (pathname: string) => ({ pathname, search: searchParams.toString() })

  return (
    <KitchensinkShell
      variant='spa'
      appTitle='Web Tracking SPA Kitchensink'
      config={config}
      onParamChange={onParamChange}
      nav={KITCHENSINK_PAGES.map(page => (
        <NavLink
          key={page.slug}
          to={withSearch(page.spaPath)}
          style={({ isActive }) => navLinkStyle(isActive)}
        >
          {page.label}
        </NavLink>
      ))}
    >
      <Routes>
        <Route path='/' element={<Navigate to={withSearch('/home')} replace />} />
        <Route path='/home' element={<HomePage />} />
        <Route path='/page-a' element={<PageA />} />
        <Route path='/page-b' element={<PageB />} />
        <Route path='/email' element={<EmailPage />} />
        <Route path='/engagement' element={<EngagementPage />} />
        <Route path='/file-download' element={<FileDownloadPage />} />
        <Route path='/tracking-toggle' element={<TrackingTogglePage />} />
        <Route path='/product-impression' element={<ProductImpressionPage />} />
        <Route path='/event-queue' element={<EventQueuePage />} />
        <Route path='/click-ids' element={<ClickIdsPage />} />
        <Route path='/consent' element={<ConsentPage />} />
        <Route path='/reinit' element={<ReinitPage />} />
        <Route path='/liftai' element={<LiftAiPage />} />
      </Routes>
    </KitchensinkShell>
  )
}

export const App = () => (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
)
